function MorphedSVG(elemNode, firstPath, secondPath){
    this.elem = elemNode;
    this.path = this.elem.getElementsByTagName('path')[0];
    this.anim = this.path.getElementsByTagName('animate')[0];
    this.animDur = parseFloat(this.anim.getAttribute('dur')) * 1000;

    this.originalPath = this.path.getAttribute('d');
    this.firstPath = firstPath;
    this.secondPath = secondPath;
    this.state = MorphedSVG.STATE_1;

    this.timeout;
}

MorphedSVG.STATE_1 = true;
MorphedSVG.STATE_2 = false;

MorphedSVG.prototype.toState = function(state) {
    if (state === this.state) return;

    switch (state) {
        case MorphedSVG.STATE_1:
            this._set(this.firstPath, this.secondPath, this.firstPath);
            break;

        case MorphedSVG.STATE_2:
            this._set(this.secondPath, this.firstPath, this.secondPath);
            break;
    }

    this.state = state;
    this.anim.beginElement();

    if (this.originalPath && this.animDur) {
        this.timeout ? clearTimeout(this.timeout) : null;
        this.timeout = setTimeout(this._resetOriginal.bind(this), this.animDur);
    }
}

MorphedSVG.prototype.toggle = function() {
    this.toState(!this.state);
}

MorphedSVG.prototype._set = function(d, from, to) {
    this.path.setAttribute('d', d);
    this.anim.setAttribute('from', from);
    this.anim.setAttribute('to', to);
}

MorphedSVG.prototype._resetOriginal = function() {
    if (this.state === MorphedSVG.STATE_1) {
        this._set(this.originalPath, '', '');
    }
}

export default MorphedSVG;
